import React from 'react'
import ReactECharts from 'echarts-for-react';
import { ReportViewModel } from '../../model/ReportViewModel'
import styled from 'styled-components';
import moment from 'moment';
import SortableTable from '../table/SortableTable';
import { FaExclamation } from 'react-icons/fa';
import { chartColors } from './chartColors';

interface IProps {
    view:ReportViewModel
}


const Section = styled.section`
.has-announcement-on-date {
    color:red;
    margin-left:1.5rem;   
}
`;

 
const DateColumn = 'Date'
const headers:string[] = [
    DateColumn,
    'Trade Count',
    'Trade Value $',
    'Avg Trade Size $',
    // 'VWAP',
    'High $',
    'Low $',
    'Close $'
]

const TradesSummary:React.FC<IProps> = (props:IProps)=>{
    
    const { view } = props;
    const options = {
        title: {
            text: `Trade Count & Average Trade Size in ${view.ticker.toUpperCase()}.ASX`,
            subtext: `Period: (${view.startDate} - ${view.endDate})`,
            left: 'center',
            textStyle: { fontSize: 16, fontWeight: 'normal' }
        },
        tooltip: { trigger: 'axis', axisPointer: { type: 'cross' } },
        legend: { orient: 'vertical', left: 120, top: 10 },
        grid: { left: 70, right: 70, top: 80, bottom: 40 },
        xAxis: { type: 'category', data: view.tradeAnalysis.items.map(x=>moment(x.day).format('D MMM')) },
        yAxis: [{
            type: 'value',
            name: 'Trade Count',
            nameLocation: 'middle',
            nameGap: 45,
            nameTextStyle: { color: chartColors[0] },
        }, {
            type: 'value',
            name: 'Average Trade size',
            nameLocation: 'middle',
            nameGap: 45,
            nameTextStyle: { color: chartColors[1] },
            splitLine: { show: false },
        }],
        series: [{
            name: 'Trade Count',
            type: 'bar',
            data: view.tradeAnalysis.items.map(x=>x.numTrades),
            color: chartColors[0],
        }, 
        {
            name: 'Average Trade Size ($k)',
            type: 'line',
            smooth: true,
            yAxisIndex: 1,
            data: view.tradeAnalysis.items.map(x=>x.avgSize/1000),
            color: chartColors[1],
        }]
    }


    const data:any[][] = [];
    for(let row of view.tradeAnalysis.items){
        const arr:any[] = [
            new Date(row.day),
            row.numTrades,
            row.trVal,
            row.avgSize,
            // row.vwap,
            row.high,
            row.low,
            row.close,
            row
        ]
        data.push(arr)
    }

    const cellFormatter = (columnName:string, cell:any, item:any):React.ReactNode => {
        if(columnName===DateColumn){
            let title = '';
            if(item.announcements.length > 0){
                title = item.announcements.map((x:any)=>x.headline).join('\n');
            }
            return <span title={title}>
                {moment(cell).format('DD MMM YY')}
                { !!title && <span className="has-announcement-on-date"><FaExclamation /></span> }
             </span>
        }
        return null;
    }

    
    return <Section>
        <h3>Trades</h3>                
        <ReactECharts option={options} notMerge={true} style={{ height: 400 }} />

        <hr/>

        <SortableTable headers={headers} data={data} cellFormatter={cellFormatter} />

    </Section>
    
}

export default TradesSummary;
